export const FETCH_CLOSED_OFFERS = "FETCH_CLOSED_OFFERS";